export default "__VITE_ASSET__DYTNgC70__"